const config = {
	noindex: process.env.NEXT_PUBLIC_ROBOTS_NO_INDEX === 'true' ? true : false,
	nofollow: process.env.NEXT_PUBLIC_ROBOTS_NO_INDEX === 'true' ? true : false
}

export default config
